import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vali ostukorvis "Maksa kolmes osas" ja saad jagada oma makse 3 kuu peale. Lisatasusid ei kaasne.

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  Ставка затратности кредита рассрочки Inbank составляет 34,77% в год на следующих примерных условиях: сумма рассрочки 500 €, период договора 6 месяцев, процентная ставка 12,99% от суммы покупки, первый взнос 0%, плата за управление 2,99 €, плата за договор 0 €, ежемесячный платеж 92,46 €, общая сумма выплат 554,74 €. Вы можете отправить запрос на оплату в рассрочку в корзине, выбрав в качестве способа оплаты Рассрочка.
*/
/* @__NO_SIDE_EFFECTS__ */
const m601 = msg(
  mf`Vali ostukorvis "Maksa kolmes osas" ja saad jagada oma makse 3 kuu peale. Lisatasusid ei kaasne.`,
  mf``,
  mf`Ставка затратности кредита рассрочки Inbank составляет 34,77% в год на следующих примерных условиях: сумма рассрочки 500 €, период договора 6 месяцев, процентная ставка 12,99% от суммы покупки, первый взнос 0%, плата за управление 2,99 €, плата за договор 0 €, ежемесячный платеж 92,46 €, общая сумма выплат 554,74 €. Вы можете отправить запрос на оплату в рассрочку в корзине, выбрав в качестве способа оплаты Рассрочка.`,
)

export { m601 as 'w.module.product.monthly_pay.disclaimer' }